
export const SkeletonCard = () => {
    const div = document.createElement('div');
    div.className = "flex-shrink-0 w-32 md:w-44 flex flex-col gap-2 animate-pulse";
    div.innerHTML = `
        <div class="aspect-[3/4] bg-gray-200 rounded-lg"></div>
        <div class="h-4 bg-gray-200 rounded w-3/4"></div>
        <div class="h-3 bg-gray-200 rounded w-1/2"></div>
    `;
    return div;
};
